import React from 'react';
import {useIntl} from "react-intl";
import {usePriceQuoteDetailsContext} from '../../contexts/PriceQuoteDetailsContext';
import {TextSuggestionsProvider} from "../../../_common/contexts/TextSuggestionsContext";
import AnimatedUploadingFilePopUp from "../../../_common/components/AnimatedUploadingFilePopUp";
import Spinner from '../../../_common/components/Spinner';
import Unit from "../../../_common/components/Unit";
import ButtonAction from "../../../_common/components/ButtonAction";
import FieldFindCustomers from "../../../_common/components/FieldFindCustomers";
import PopupAddCustomer from "../../../CustomersEntity/components/PopupAddCustomer";
import FieldFindContacts from "../../../_common/components/FieldFindContacts";
import PopupAddContact from "../../../ContactsPage/components/PopupAddContact";
import styles from "../styles.module.scss";
import {FormikProvider} from "formik";

const TabCustomers = () => {
  const {
    loadingFile,
    formik,
    submit,
    loadingData,
    isEdit,
    switchToSecondTab
  } = usePriceQuoteDetailsContext();
  const {formatMessage} = useIntl();
  const prefix = 'price-quote-details';
  const {isValid} = formik;

  return (
    <FormikProvider value={formik}>
      <TextSuggestionsProvider>
        <AnimatedUploadingFilePopUp show={loadingFile}/>
        {loadingData
          ? <Spinner customContainerStyles='d-flex align-items-center justify-content-center'/>
          : (
            <>
              <div className={styles.customersContainer}>
                <Unit
                  text={formatMessage({id: `customers`, defaultMessage: 'Customers'})}
                  icon={'/media/common/Group_pink.svg'}
                >
                  <FieldFindCustomers
                    name='customers'
                    formik={formik}
                    customLabel={
                      <div className='d-flex position-relative w-100'>
                        <div>
                          {formatMessage({id: 'typeahead-customer-label', defaultMessage: 'Search customers'})}
                          <span className='text-danger'>*</span>
                        </div>
                        <div style={{position: 'absolute', top: '-45px', whiteSpace: 'nowrap', left: 0}}>
                          <PopupAddCustomer formikProps={formik}/>
                        </div>
                      </div>
                    }
                    customContainerStyles='w-100'
                    customListStyles={styles.customersList}
                  />
                </Unit>
                <Unit
                  text={formatMessage({id: `contacts`, defaultMessage: 'Contacts'})}
                  icon={'/media/common/User_orange.svg'}
                >
                  <FieldFindContacts
                    name={'contacts'}
                    formik={formik}
                    customLabel={
                      <div className='d-flex position-relative w-100'>
                        <div>{formatMessage({id: 'typeahead-contact-label', defaultMessage: 'Search contact'})}</div>
                        <div style={{position: 'absolute', top: '-45px', whiteSpace: 'nowrap', left: 0}}>
                          <PopupAddContact formikProps={formik}/>
                        </div>
                      </div>
                    }
                    customContainerStyles='w-100'
                    customListStyles={styles.customersList}
                  />
                </Unit>
              </div>
              <div className={'d-flex align-items-center justify-content-center mt-8'}>
                <ButtonAction
                  onClick={async () => {
                    await submit(false);
                    switchToSecondTab();
                  }}
                  disabled={!isValid}
                  useIcon={'/media/common/Check-in-circle_white.svg'}
                  label={formatMessage({
                    id: `${prefix}-button-label-${isEdit ? 'edit' : 'create'}`,
                    defaultMessage: `${isEdit ? 'Edit' : 'Create'}`
                  })}
                  customClassnames={'w-150px'}
                />
              </div>
            </>
          )}
      </TextSuggestionsProvider>
    </FormikProvider>
  );
};

export default TabCustomers;